import { render, staticRenderFns } from "./approvalTemplate.vue?vue&type=template&id=92841970&scoped=true"
import script from "./approvalTemplate.vue?vue&type=script&lang=js"
export * from "./approvalTemplate.vue?vue&type=script&lang=js"
import style0 from "./approvalTemplate.vue?vue&type=style&index=0&id=92841970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92841970",
  null
  
)

export default component.exports